export const getElapsedHours = (startDate: Date, endDate: Date) => {
  return Math.floor(Math.abs(startDate.getTime() - endDate.getTime()) / 36e5);
};

export const getRemainingHours = (startDate: Date, endDate: Date) => {
  const remaining = Math.ceil((startDate.getTime() - endDate.getTime()) / 36e5);
  return remaining <= 0 ? 0 : remaining;
};
